import { render, staticRenderFns } from "./PackIcon.vue?vue&type=template&id=7b8bb64f"
import script from "./PackIcon.vue?vue&type=script&lang=js"
export * from "./PackIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports